import React from "react";
import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from "@/components/ui/accordion";

const faqs = [
  {
    q: "¿Bancoorp otorga créditos directamente?",
    a: "No. Bancoorp es un intermediario de crédito. No somos banco ni una institución financiera regulada. Nuestra labor es conectar a las personas con entidades financieras que sí otorgan créditos. La aprobación y las condiciones finales dependen exclusivamente de la entidad financiera.",
  },
  {
    q: "¿Qué significa que la tasa sea “desde 1% mensual”?",
    a: "La tasa de 1% mensual es una tasa referencial mínima. La tasa efectiva que te ofrecerá una entidad financiera dependerá de tu perfil crediticio, monto, plazo y la política de riesgo de la entidad. No garantizamos ni prometemos esa tasa para ningún cliente.",
  },
  {
    q: "¿Tiene costo usar Bancoorp?",
    a: "No. Comparar opciones y recibir ofertas a través de Bancoorp es completamente gratuito. Los costos asociados al crédito (intereses, CAE, seguros, comisiones) corresponden al contrato que firmes directamente con la entidad financiera.",
  },
  {
    q: "¿Qué es la CAE?",
    a: "CAE significa Carga Anual Equivalente. Es un indicador exigido por la ley chilena que expresa el costo total del crédito en términos de una tasa anual, incluyendo intereses, comisiones y gastos asociados. Te permite comparar créditos de forma estandarizada.",
  },
  {
    q: "¿Cuál es el plazo mínimo del crédito?",
    a: "Según la regulación chilena, las operaciones de crédito de dinero deben tener un plazo igual o superior a 61 días. Los plazos máximos dependen de la entidad financiera y el monto solicitado.",
  },
  {
    q: "¿Recibir ofertas implica obligación de aceptar?",
    a: "No. Tú decides libremente si quieres aceptar alguna de las ofertas que recibas. Nunca estás obligado a contratar un crédito a través de Bancoorp o sus entidades aliadas.",
  },
  {
    q: "¿Qué pasa con mis datos personales?",
    a: "Tus datos se utilizan para conectar tu solicitud con las entidades financieras aliadas. Respetamos la Ley N° 19.628 sobre protección de la vida privada. Puedes revisar el detalle en nuestra Política de Privacidad.",
  },
  {
    q: "¿Qué hago si tengo problemas para pagar una cuota?",
    a: "Te recomendamos contactar directamente a la entidad financiera con la que firmaste el crédito. El no pago puede generar intereses moratorios, gastos de cobranza y afectar tu historial crediticio. Infórmate antes de endeudarte.",
  },
];

export default function FAQ() {
  return (
    <section
      id="faq"
      className="py-20 lg:py-28 bg-white"
      data-testid="faq-section"
    >
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="max-w-3xl">
          <span className="text-sm uppercase tracking-[0.2em] font-bold text-blue-600">
            Preguntas frecuentes
          </span>
          <h2 className="mt-3 text-3xl sm:text-4xl lg:text-5xl font-bold tracking-tight text-slate-900">
            Resolvemos tus dudas antes de solicitar
          </h2>
        </div>

        <Accordion
          type="single"
          collapsible
          className="mt-10 space-y-3"
          data-testid="faq-accordion"
        >
          {faqs.map((f, i) => (
            <AccordionItem
              key={i}
              value={`item-${i}`}
              className="rounded-xl border border-slate-200 bg-slate-50 px-5"
              data-testid={`faq-item-${i}`}
            >
              <AccordionTrigger className="text-left font-semibold text-slate-900 hover:no-underline py-5">
                {f.q}
              </AccordionTrigger>
              <AccordionContent className="text-slate-600 leading-relaxed pb-5">
                {f.a}
              </AccordionContent>
            </AccordionItem>
          ))}
        </Accordion>
      </div>
    </section>
  );
}
